import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useReportProductDoInitContext } from "contexts/reportProductDoPage/ReportProductDoInitContext";
import { useFormikContext } from "formik";
import { ModalAllder } from "layouts/ModalAllder";
import { ProductMultiSelect } from "layouts/ProductMultiSelect";
import React, { useState } from "react";
export default function ReportProductDoModalGroup() {
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, setFieldValue = _useFormikContext.setFieldValue;
    var _useReportProductDoInitContext = useReportProductDoInitContext(), modalReportProductDoState = _useReportProductDoInitContext.modalReportProductDoState, setFormData = _useReportProductDoInitContext.setFormData, options = _useReportProductDoInitContext.options;
    var modalProductSelect = modalReportProductDoState.modalProductSelect, setModalProductSelect = modalReportProductDoState.setModalProductSelect;
    var handleRowSelectOverrideReportProductDo = function(param) {
        var ids = param.ids;
        var newIds = ids;
        if (newIds.length === 0 && values.dimProductPriceIDList.length > 0 && values.dimProductPriceIDList.length !== 1) {
            return;
        }
        // ป้องกันซ้ำแล้วเซตเข้า form
        var uniqueIds = Array.from(new Set(newIds));
        setFieldValue("dimProductPriceIDList", uniqueIds);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(ModalAllder, {
            modal: modalProductSelect,
            setModal: setModalProductSelect,
            htitle: "เพิ่มสินค้าหลายรายการ",
            hbtn: true,
            children: /*#__PURE__*/ _jsx(ProductMultiSelect, {
                optionsMstVat: options.vat,
                values: values,
                selected: values.dimProductPriceIDList,
                handleRowSelectOverride: handleRowSelectOverrideReportProductDo
            })
        })
    });
}
